<div class="f-home__header">
  <div
    (click)="onChangeMenuSizeClass(menuSizeClass)"
    [ngClass]="menuSizeClass"
    class="hamburger"
  >
    <fa-icon [icon]="['fas', 'bars']"></fa-icon>
  </div>

  <!--  Для Нового года потом раскомментировать-->

    <div class="f-home__logo">
      <div class="f-home__logo-wrapper">
        <a [routerLink]="['/']">
          <img
            alt="TRportal"
            class="img__f-home__logo"
            src="/assets/images/svg/logo.svg"
          />
        </a>
      </div>
    </div>

  <!--  Для Нового года потом удалить, про стили тоже не забыть-->

<!--  <div class="f-home__logo">-->
<!--    <div class="f-home__logo-wrapper">-->
<!--      <a [routerLink]="['/']">-->
<!--        <img-->
<!--          alt="TRportal"-->
<!--          class="img__f-home__logo"-->
<!--          src="/assets/images/svg/logo.svg"-->
<!--        />-->
<!--        <img-->
<!--          alt="bells"-->
<!--          class="f-home__bells-img"-->
<!--          src="/assets/images/bells.png"-->
<!--        />-->
<!--      </a>-->
<!--    </div>-->
<!--  </div>-->

  <div *ngIf="design === 'classic'" class="f-home__new-design">
    <button (click)="goToModernDesign()" class="btn-new-design">
      {{ "menu.go_to_modern_design" | translate }}
    </button>
  </div>

  <!-- -------------------------------- -->

  <div class="f-home__header-user">
    <div class="user-info">
      <div class="user-info-data">
        <a [routerLink]="['/', 'settings', 'user']" class="settings-user">
          <span class="login">{{ user.login }}</span>
        </a>
      </div>
      <div class="avatar">
        <a [routerLink]="['/', 'settings', 'user']">
          <ng-container *ngIf="user.photoUrlSmallSize; else noAva">
            <img
              class="avatar-icon avatar-icon__border"
              src="{{ user.photoUrlSmallSize }}"
            />
          </ng-container>
          <ng-template #noAva>
            <fa-icon
              [icon]="['fas', 'user-circle']"
              class="no-avatar"
            ></fa-icon>
          </ng-template>
        </a>
      </div>
    </div>
  </div>
</div>
